export interface ISoftware {
  Title: string;
  eSystemCode: string;
  eSystemType: string;
  eDescription: string;
  eTeam: string;
  eITHead: string;
  eITStaff: string;
  eITTeamLead: string;
  eTeamLeadName: string;
  eITHeadName: string;
  id: string;
}

export const eSystemType = [
  {
    label: "Nội bộ",
    value: "Internal",
  },
  {
    label: "Bên ngoài",
    value: "External",
  },
];
